
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { DeviceAPI } from "@/common/api/userManage/deviceList";
import { CommonApi } from "@/common/api/common";

import { getCommonList,shareConfirmOptions } from '@/common/config';
import {DeepLoop} from '@/common/deepLoop/deepLoop';

export const pageApiList = getPageAPIs(DeviceAPI);

const defaultAddForm: any = {
  name:'',
  is_type:null,
  // resource:'',
  device_id:'',
  is_vai: 0, // 是否存在电视 0否 1是
}


// 设备类型1:0未知 1ai 2非ai 3墙壁氛围灯 4蓝牙开关
const deviceType2ch: any[] = ['未知','ai','非ai','墙壁氛围灯','蓝牙开关']
const defaultDeviceTypeList = getCommonList(deviceType2ch, 1);

// // 开关状态1:开0关
const deviceStatus2Tag: any[] = [
  {
    type: 'danger',
    label: '离线'
  },
  {
    type: '',
    label: '在线'
  }
]

@Component({
  filters: {
    showDeviceTypeName(type: number) {
      return deviceType2ch[type] || '未知'
    }
  }
})
export default class DeviceList extends Vue {
  private utilInstance: any;
  private deviceApi: any;

  private commonApi: any;

  private deepLoopUtil: any = {};

  private deviceStatus2Tag: any[] = [
    ...deviceStatus2Tag
  ]

  private deviceTypeList:any = []

  private addForm:any = {
   
  }

  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.deviceApi = new DeviceAPI();

    this.commonApi = new CommonApi();

    this.utilInstance = new Util();
    //
    this.deviceTypeList = [
      ...this.deepLoopUtil.deepCopy(defaultDeviceTypeList),
    ];

    this.addForm = {
      ...this.deepLoopUtil.deepCopy(defaultAddForm)
    }
  }

  private get shopId() {
    const route = this.$route 

    const {
      query = {}
    } = route || {}

    const {
      shop_id = ''
    } = query
    return shop_id
  }

  private firstLoading: boolean = true;

  private form: any = {

  };
  private dialogVisible:boolean  = false
  private openType:number = 1 // 1增加 2编辑
  
  private get isShowVaiSwitch() {
    const addForm = this.addForm

    const {
      is_type
    } = addForm || {}

    const allowVaiSwitchTypes: number[] = [1, 2]

    return allowVaiSwitchTypes.includes(is_type)
  }

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.deviceApi.getDeviceTableList(
      this.getDeviceTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getDeviceTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {

    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {
      shop_id: this.shopId
    };


    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;
      // outerParams.__isUnique = !firstLoading;
    }


    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }


  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private addEditForm(type:number=1,row:any={}){
    this.addForm = {
      ...this.deepLoopUtil.deepCopy(defaultAddForm)
    }
    this.openType = type
    if(this.openType===2){
      const { name,is_type,id,thing_name, is_vai = 0 } = row
      this.addForm = {
        name,
        is_type,
        // resource,
        device_id:thing_name,
        id,
        is_vai
      }
    }
    this.dialogVisible = true
  }

  private handleOpenDebug(row:any){
    const {thing_name} = row
    const url = `http://${thing_name}.molis.store:9528/`
    window.open(url,'_blank')
  }

  private handleGoBluetooth(row:any){
    const {
      id
    } = row || {}

    if (id) {
      this.$router.push({
        path: "/blueToothList",
        query: {
          id: id,
        },
      });
    }
  }



  private unbindDevice(id: string): void {
    this.$confirm("确认删除该设备吗？", "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.deviceApi.unbindDevice(
          {
            id: id,
          },
          () => {
            this.$message.success("删除成功");
            this.getTable();
          }
      );
    });
  }
  private handleComfirm() {

    this.addForm['shop_id'] = this.shopId

    const params = {
      ...this.addForm
    }

    if (!this.isShowVaiSwitch) {
      delete params.is_vai
    }
    

    if(this.openType===1){
      this.deviceApi.addDevice(params,
          () => {
            this.$message.success('新增成功');
            this.dialogVisible = false;
            this.getTable();
          },
          () => {
          }
      );
    }else{
      this.deviceApi.updateDevice(params,
          () => {
            this.$message.success('编辑成功');
            this.dialogVisible = false;
            this.getTable();
          },
          () => {
          }
      );
    }

  }
}
